import React, { Component } from 'react';
import { connect } from 'react-redux'
import ReactDOM from 'react-dom'
import { withRouter } from 'react-router-dom'
import '../../../static/css/adminlte.css'
// import '../../../static/css/custom_adminlte.css'
import '../../../static/css/blue-skin.css'
import '../../../static/css/custom_bootstrap.css'
import '../../../static/css/custom.css'

import '../static/css/dashboard.css'
import { logoutRequest } from '../../../redux/user'



class Header extends Component {

    constructor(props) {
        super(props)
        this.state = {
            isUserMenuOpened: false,
        }
        this.node = null
    }

    componentDidMount() {
        document.body.className += " sidebar-open"
        document.addEventListener('mousedown', this.handleClickOutside)
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside)
    }

    handleClickOutside = (e) => {
        let userMenuDropdown = ReactDOM.findDOMNode(this.refs.usermenu_dropdown)
        if (this.state.isUserMenuOpened && !this.node.contains(e.target)) {
            userMenuDropdown.className = userMenuDropdown.className.replace(" open", "")
            this.setState(Object.assign({}, this.state, { isUserMenuOpened: !this.state.isUserMenuOpened }))
        }
    }

    collapseSidebar = () => {
        document.body.className = document.body.className.replace(" sidebar-open", " sidebar-collapse")
    }

    openSidebar = () => {
        document.body.className = document.body.className.replace(" sidebar-collapse", " sidebar-open")
    }

    onUserMenuClick = () => {
        let userMenuDropdown = ReactDOM.findDOMNode(this.refs.usermenu_dropdown)
        if (this.state.isUserMenuOpened) {
            userMenuDropdown.className = userMenuDropdown.className.replace(" open", "")
        } else {
            userMenuDropdown.className += " open"
        }
        this.setState(Object.assign({}, this.state, { isUserMenuOpened: !this.state.isUserMenuOpened }))
    }

    onLogoutCall = () => {
        this.onUserMenuClick()
        this.props.history.push("/dashboard")
        this.props.dispatch(logoutRequest(false))
    }

    onResetPasswordClick = () => {
        this.onUserMenuClick()
        this.props.history.push("/dashboard/resetpassword")
    }

    onLogoClick = () => {
        this.props.history.push("")
    }


    toggleClick = () => {
        
        var element = document.getElementById("navIconId");
        if(element.className==="fa fa-bars"){
            element.className="fa fa-times"
        }else{
            element.className="fa fa-bars"
        }
    }

    render() {
        let HBB_logo = require('../static/img/bbms-logo.png')
        let HBB_small_logo = require('../static/img/bbms-logo-small.png')
        let profile_pic = require('../static/img/user.png')
        let env=window.location.hostname
        this.props.isSideBarOpened ? this.openSidebar() : this.collapseSidebar()
        return (
            <header className="header-background main-header">
                {(() => {
                    if(env==="localhost"){
                        return(
                            <a className="logo" onClick={this.onLogoClick}>
                                <span className="logo-mini text-color" style={{ fontWeight: 600 }}>
                                    <p>Local</p>
                                </span>
                                <div>
                                   <p>HBB Local</p>
                                </div>
                            </a>
                        )       
                    }else if(env==="app-stage.hybb.in"){
                        return( 
                            <a className="logo" onClick={this.onLogoClick}>
                                <span className="logo-mini text-color" style={{ fontWeight: 600 }}>
                                    <p>Stage</p>
                                </span>
                                <div>
                                    <p>HBB Stage</p>
                                </div>
                            </a>
                        )
                    }else{
                        return( 
                            <a className="logo" onClick={this.onLogoClick}>
                                <span className="logo-mini text-color" style={{ fontWeight: 600 }}>
                                    <img style={{ height: '45px' }} alt="GMS logo"
                                    src={HBB_small_logo} />
                                </span>
                                <div>
                                    <img style={{ height: '45px' }} alt="GMS logo"
                                            src={HBB_logo} />
                                </div>
                            </a>
                        )
                    }
                })()}   

                <nav className="navbar navbar-static-top">
                    <a
                        className="sidebar-toggle text-color"
                        data-toggle="offcanvas"
                        role="button"
                        onClick={(e) => {
                            e.preventDefault()
                            this.props.callBack()
                            this.toggleClick()
                        }}>
                        <span className="sr-only">Toggle navigation</span>
                        <i  id="navIconId" className="fa fa-bars" style={{color: 'black',fontStyle: 'normal'}}></i>
                    </a>
                    <a className="header-position">
                        <span className='header-title'>{this.props.user.headerTitle}</span>
                        <span className='header-title' style={{"fontWeight": 800,"color": "teal"}}>{this.props.user.subHeaderTitle}</span>
                    </a>
                    <div className="navbar-custom-menu">
                        <ul className="nav navbar-nav" ref={node => { this.node = node }}>
                            <li className="dropdown user user-menu" ref="usermenu_dropdown">
                                <a
                                    className="dropdown-toggle"
                                    data-toggle="dropdown"
                                    onClick={(e) => {
                                        e.preventDefault()
                                        this.onUserMenuClick()
                                    }}>
                                    <img src={profile_pic} className="user-image" alt="User Pic" />
                                    <span className="hidden-xs text-color">{this.props.user.name}</span>
                                </a>
                                <ul className="dropdown-menu">
                                    <li className="user-header">
                                        <img src={profile_pic} className="img-circle" alt="User Pic"
                                             onClick={(e) => {
                                                 e.preventDefault()
                                                 this.props.history.push("/registration")
                                             }} />
                                        <p>
                                            {this.props.user.name}-{this.props.user.user_type}
                                        </p>
                                    </li>
                                    <li className="user-footer">
                                        <div className="pull-left">
                                        </div>
                                        <div className="pull-left" onClick={this.onResetPasswordClick}>
                                            <a className="btn btn-default btn-flat">Reset Password</a>
                                        </div>
                                        <div className="pull-right" onClick={this.onLogoutCall}>
                                            <a className="btn btn-default btn-flat">Sign out</a>
                                        </div>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </nav>
            </header>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        user: state.user,
    }
}

export default connect(mapStateToProps)(withRouter(Header))


// WEBPACK FOOTER //
// ./src/modules/Dashboard/Components/Header.js